import * as React from 'react';

export const useSetDocumentTitle = function useSetDocumentTitle(title: string) {
	React.useEffect(() => {
		if (document.title !== title) {
			document.title = title;
		}
	}, [title]);
};
